import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-close-icon',
  imports: [],
  templateUrl: './close-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './close-icon.component.scss',
})
export class CloseIconComponent {}
